import { render, staticRenderFns } from "./GroupResourcePermission.vue?vue&type=template&id=8e3f47e2&scoped=true"
import script from "./GroupResourcePermission.vue?vue&type=script&lang=js"
export * from "./GroupResourcePermission.vue?vue&type=script&lang=js"
import style0 from "./GroupResourcePermission.vue?vue&type=style&index=0&id=8e3f47e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3f47e2",
  null
  
)

export default component.exports